import { render } from "./RenovaBlog.vue?vue&type=template&id=37433c8a&scoped=true"
import script from "./RenovaBlog.vue?vue&type=script&lang=js"
export * from "./RenovaBlog.vue?vue&type=script&lang=js"

import "./RenovaBlog.vue?vue&type=style&index=0&id=37433c8a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37433c8a"]])

export default __exports__